import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Paper } from '../paper';
import { withVersion } from '../utils';
import { MagicAiChat } from './chat';
const MagicAIAssistImpl = React.forwardRef(({ elevation = 'L', className, 'data-role': dataRole = 'magic-ai-assist', 'data-role-value': dataRoleValue, ...chatProps }, ref) => {
    return (_jsx(Paper, { ref: ref, variant: "elevation", elevation: elevation, className: className, width: "100%", height: "100%", "data-role": dataRole, "data-role-value": dataRoleValue, children: _jsx(MagicAiChat, { ...chatProps }) }));
});
export const MagicAIAssist = withVersion(MagicAIAssistImpl, '1.0.0');
export default MagicAIAssist;
